/* Scoped "Read more" for collection banner description */
(function () {
  function ready(fn){ 
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once:true });
  }

  ready(function () {
    document.querySelectorAll('.sc-desc').forEach(function (root) {
      var content = root.querySelector('.sc-desc__content');
      var btn = root.querySelector('.sc-desc__toggle');
      if (!content || !btn) return;

      var mq = window.matchMedia('(max-width: 768px)');

      function isOverflowing() {
        // Temporarily apply clamp to measure clamped height
        var prevClamp = content.style.webkitLineClamp;
        var lines = getComputedStyle(content).getPropertyValue('--sc-desc-lines') || '6';
        content.style.webkitLineClamp = lines;
        content.classList.remove('is-expanded');
        var clampedH = content.scrollHeight;

        // Expand to get full height
        content.classList.add('is-expanded');
        content.style.webkitLineClamp = '';
        var fullH = content.scrollHeight;

        // Re-clamp for the next paint
        content.classList.remove('is-expanded');
        content.style.webkitLineClamp = prevClamp || lines;

        return fullH > clampedH + 2;
      }

      function apply() {
        if (mq.matches) {
          var showToggle = isOverflowing();
          btn.hidden = !showToggle;
          content.classList.remove('is-expanded');
          btn.setAttribute('aria-expanded', 'false');
          btn.textContent = 'Read more';
        } else {
          // Desktop: always fully expanded, no button
          content.classList.add('is-expanded');
          btn.hidden = true;
          btn.setAttribute('aria-expanded', 'true');
          btn.textContent = 'Read more';
        }
      }

      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        expanded = !expanded;
        btn.setAttribute('aria-expanded', String(expanded));
        content.classList.toggle('is-expanded', expanded);
        btn.textContent = expanded ? 'Read less' : 'Read more';
      });

      apply();
      window.addEventListener('resize', apply, { passive: true });
    });
  });
})();
